<template>
    <simple-dropdown class="select-dropdown-button"
                     :dropdown-wrapper-style="{'margin-top': 0, 'min-width': '152px'}">
        <template v-slot:triggerButtonContent>
            <div class="wrapper button-like">
                <div class="primary" @click.stop="selectPage">
                    Select Current Page
                </div>
                <span class="more"><i></i><i></i><i></i></span>
            </div>
        </template>
        <template v-slot:dropdownMenu>
            <ul>
                <li>
                    <button @click="selectAll">
                        <span>Select All Pages</span>
                    </button>
                </li>
                <li>
                    <button @click="clearAll">
                        <span>Clear All Selected</span>
                    </button>
                </li>
            </ul>
        </template>
    </simple-dropdown>
</template>

<script>
    import SimpleDropdown from "@/components/SimpleDropdown";

    export default {
        name: "SelectDropdownButton",
        components: {SimpleDropdown},
        methods: {
            selectPage() {
                this.$emit('selectPage')
            },
            selectAll() {
                this.$emit('selectAll')
            },
            clearAll() {
                this.$emit('clearAll')
            }
        }
    }
</script>

<style scoped lang="scss">
    .wrapper {
        display: inline-flex;
        align-items: center;
    }

    .button-like {
        cursor: pointer;
        padding: 0;
        border: 1px solid rgba(black, 0.18);
        border-radius: 4px;
        font-size: inherit;
        line-height: 1.25em;
        font-weight: 500;
        outline: none;
        white-space: nowrap;

        &:hover {
            border: 1px solid rgba(black, 0.32);
            .more {
                border-left: 1px solid rgba(black, 0.32);
            }
        }
    }

    .primary {
        padding: 3px 5px 3px 8px;
        color: #333333;

        &:hover {
            background-color: rgba(black, 0.06);
            color: black;
        }

        &:active {
            box-shadow: inset 0 0 4px rgba(black, 0.2);
        }
    }

    .more {
        padding: 3px 3px 3px 3px;
        border-left: 1px solid rgba(black, 0.18);

        i {
            width: 2px;
            height: 2px;
            border-radius: 50%;
            background-color: gray;
            margin: 1px;
            display: inline-block;
            vertical-align: middle;
        }

        &:hover {
            background-color: rgba(black, 0.06);

            i {
                background-color: black;
            }
        }
    }

    .select-dropdown-button.active {
        .button-like {
            border: 1px solid rgba(black, 0.32);
        }

        .more {
            background-color: rgba(black, 0.1);

            i {
                background-color: black;
            }
        }
    }
</style>
